import React from 'react';
import { cn } from '@/lib/utils';
import { SYMBOL_PATH } from '../../brand';

/** Small inline Aimdoc symbol in currentColor, used as the AI-message marker. */
export const AimdocMark = ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" className={cn("w-3.5 h-3.5", className)} aria-hidden="true">
        <path fill="currentColor" fillRule="evenodd" d={SYMBOL_PATH} />
    </svg>
);

export default AimdocMark;
